export default "__VITE_ASSET__W6QqWppv__"